/**
 * 区域管理-小区列表
 */
import type { PageContext } from '@zto/zpage'
import { UI_PAGE_EVENTS } from '@zto/zpage-ui-element'
import dayjs from 'dayjs'
import { communityDialog } from './_dialogs'

export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/sys/admin/api/region/community/pageList',
        method: 'POST',
        responseTransform: (res: any) => {
          if (res && Array.isArray(res.list)) {
            return { data: res.list, total: res.total || 0 }
          }
          return res
        }
      },
      add: {
        label: '添加',
        api: '/sys/admin/api/region/community/create',
        method: 'POST',
        dialog: communityDialog(false),
        successMessage: '添加成功'
      },
      edit: {
        label: '编辑',
        api: '/sys/admin/api/region/community/update',
        method: 'POST',
        dialog: communityDialog(true),
        successMessage: '保存成功'
      },
      delete: {
        label: '删除',
        api: '/sys/admin/api/region/community/delete',
        method: 'POST',
        payload: { idList: ['${data.row.id}'] },
        message: '确认删除该小区吗？'
      },
      batchDelete: {
        label: '批量删除',
        api: '/sys/admin/api/region/community/delete',
        method: 'POST',
        message: '确认批量删除已选小区吗？',
        payload: async ({ app }: PageContext, ext: any) => {
          const { Message } = app.useMessage()
          const selectedRows = ext?.selection
          if (Array.isArray(selectedRows)) {
            // if (!app.getPageSearchData().isCheck) {
            //   Message.warning('请先按供应商进行筛选后再操作推送！')
            //   return false
            // }
            const len = selectedRows?.length
            if (!len) {
              Message.warning('请至少选择一条数据！')
              return false
            }

            const idList = selectedRows.map((it: any) => it?.id).filter(Boolean)
            return {
              idList
            }
          }
        }
      }
    },
    searchOn: [UI_PAGE_EVENTS.ACTIVATED],
    search: {
      labelWidth: 100,
      items: [
        // {
        //   label: '辖区',
        //   type: 'area',
        //   props: ['provinceId', 'cityId'],
        //   labelProps: ['province', 'city'],
        //   relatedProps: ['provinceId', 'cityId', 'province', 'city'],
        //   propsConfig: { checkStrictly: true },
        //   areaLevel: 2
        // },
        // {
        //   label: '所在地区',
        //   type: 'area-pro',
        //   prop: 'receivePCD',
        //   keyConfig: {
        //     provinceCode: 'provinceCode',
        //     province: 'province',
        //     cityCode: 'cityCode',
        //     city: 'city',
        //     districtCode: 'districtCode',
        //     district: 'district'
        //   },
        //   filterable: true,
        //   span: 6
        // },
        { type: 'input', prop: 'communityCode', label: '小区编码', span: 6 },
        { type: 'input', prop: 'communityName', label: '小区名称', span: 6 },
        { type: 'input', prop: 'contactName', label: '联系人', span: 6 },
        { type: 'input', prop: 'contactMobile', label: '联系人手机号', span: 6 }
      ]
    },
    toolbar: {
      noExport: true,
      items: [{ action: 'add' }, { action: 'batchDelete' }]
    },
    table: {
      showCheckbox: true,
      operation: {
        width: 120,
        items: [{ action: 'edit' }, { action: 'delete' }]
      },
      innerAttrs: {
        operationPosition: 'left',
        noIndex: false,
      },
      columns: [
        { label: '小区编码', prop: 'communityCode', minWidth: 120 },
        { label: '小区名称', prop: 'communityName', minWidth: 140 },
        {
          label: '小区位置',
          prop: 'addressDetail',
          minWidth: 220,
          formatter: (row: any) =>{
            return [row?.province || '', row?.city || '',row?.district || '', row?.addressDetail || ''].filter(Boolean).join('-')
          }
        },
        { label: '所属年代', prop: 'buildYear', minWidth: 100 },
        {
          label: '总楼栋(栋)',
          prop: 'totalBuildingCount',
          minWidth: 100,
          formatter: (row: any) => (typeof row?.totalBuildingCount === 'number' ? `${row.totalBuildingCount}栋` : '--')
        },
        {
          label: '总单元数(单元)',
          prop: 'totalUnitCount',
          minWidth: 100,
          formatter: (row: any) => (typeof row?.totalUnitCount === 'number' ? `${row.totalUnitCount}个` : '--')
        },
        {
          label: '总户数(户)',
          prop: 'totalHouseholdCount',
          minWidth: 100,
          formatter: (row: any) => (typeof row?.totalHouseholdCount === 'number' ? `${row.totalHouseholdCount}户` : '--')
        },
        {
          label: '小区照片',
          prop: 'communityPhoto',
          component: {
            formItemType: 'file-list',
            label: '',
            listType: 'image',
            uploadType: '',
            readonly: true,
            autoHeight: true
          },
          minWidth: 120
        },
        { label: '联系人姓名', prop: 'contactName', minWidth: 120 },
        { label: '联系人手机号', prop: 'contactMobile', minWidth: 120 },
        {
          label: '添加时间',
          prop: 'gmtCreate',
          minWidth: 160,
          formatter: (row: any) => (row?.gmtCreate ? dayjs(row.gmtCreate).format('YYYY-MM-DD HH:mm:ss') : '--')
        }
      ]
    }
  }
}
